import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { DropDownItem, US_SubHeader } from "../../api/models";
import { MessageDialogComponent } from "../message-dialog/message-dialog.component";
import { ShareState } from "../../elements/share-editor/share-editor.component";

export interface ShareInteractiveDialogData {
  userSubscriptions: US_SubHeader[];
  shareState: ShareState;
}

@Component({
  selector: "share-interactive-dialog",
  templateUrl: "./share-interactive-dialog.component.html",
})
export class ShareInteractiveDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<ShareInteractiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareInteractiveDialogData,
    private dialog: MatDialog
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = data;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }
}
